/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { CommandContext } from '@ecsper/speciality-contract';
import { ExpertWitnessModule } from '@ecsper/speciality-expert-witness';

const ribbonCommandContext: CommandContext = {
  documentContext: { documentId: null, isDirty: false, hostMetadata: {} },
  session: {
    actorId: '',
    organisationId: '',
    officeId: '',
    displayName: '',
    entitlements: [],
  },
};

/**
 * Dispatches manifest ribbon actions to speciality contributions. Stage 6 preview group
 * posts to the task pane; compliance actions run Word mutations in this frame.
 */
async function dispatchRibbonAction(actionId: string): Promise<void> {
  const ribbon = ExpertWitnessModule.hosts.word?.ribbon ?? [];
  const contribution = ribbon.find((r) => r.id === actionId);
  if (contribution === undefined) {
    // eslint-disable-next-line no-console -- command surface diagnostics only
    console.warn(`Unknown ribbon action: ${actionId}`);
    return;
  }
  if (contribution.group === 'stage-6-preview') {
    window.postMessage(
      {
        type: 'ecsper:stage6-stub',
        label: contribution.label['en-GB'],
      },
      window.location.origin,
    );
    return;
  }
  await contribution.action(ribbonCommandContext);
}

async function ribbonCommandDispatch(event: Office.AddinCommands.Event): Promise<void> {
  try {
    await dispatchRibbonAction(event.source.id);
  } finally {
    event.completed();
  }
}

Office.onReady(() => {
  Office.actions.associate('ribbonCommandDispatch', ribbonCommandDispatch);
});
